import React from 'react';
import { SkillsColumn } from '../../atoms/SkillsColumn';
import styles from './SkillsColumns.module.css';

interface SkillColumn {
  title: string;
  skills: string[];
}

interface SkillsColumnsProps {
  columns: SkillColumn[];
}

export const SkillsColumns: React.FC<SkillsColumnsProps> = ({ columns }) => {
  return (
    <div className={styles.skillsColumns}>
      <div className={styles.columnsContainer}>
        {columns.map((column, index) => (
          <SkillsColumn
            key={`${column.title}-${index}`}
            title={column.title}
            skills={column.skills}
          />
        ))}
      </div>
    </div>
  );
};
